import React, { useMemo, useState } from "react";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { ReactComponent as EditIcon } from "../../../assets/svgs/edit-icon.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/deleteIcon.svg";
import { SearchBar } from "../../../components/Elements/Search/SearchBar";
import { ReactComponent as FilterIcon } from "../../../assets/svgs/filter-icon.svg";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import EditDepartment from "../CustomerDetailPage/Roles/DIalogBoxes/EditDepartment";
import AddDepartment from "../CustomerDetailPage/Roles/DIalogBoxes/AddDepartment";
import FilterLocationDeparment from "../CustomerDetailPage/Roles/DIalogBoxes/FilterLocationDepartment";
import CardsBorder from "../../../components/Cards/CardsBorder";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import { useEffect } from "react";
import { 
  fetchAllDepartments, 
  deleteDepartment, 
  updateDepartment, 
  setSelectedDepartment 
} from "../../../redux/customer/customerSlice";
import { useSelector, useDispatch } from "react-redux";
import { EnvironmentOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "antd";
import LinkLocationPopup from "./Roles/DIalogBoxes/LinkLocationPopup";
import useDebounce from "../../../hooks/debouncing";

const Department = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [addDepartments, setAddDepartments] = useState(false);
  const [openEditBox, setOpenEditBox] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
    const [selectedDeptForLink, setSelectedDeptForLink] = useState(null);
  const [openLinkPopup, setOpenLinkPopup] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({ isActive: undefined, department_type: undefined });
  const debouncedSearch = useDebounce(searchTerm, 500);
  // const [deleteConfirmation, setDeleteConfirmation] = useState({
  //   visible: false,
  //   departmentName: "",
  // });
    const [deleteConfirmation, setDeleteConfirmation] = useState({
    visible: false,
    departmentId: null,
    departmentName: "",
  });
  const [successPopup, setSuccessPopup] = useState({
    visible: false,
    title: "",
    message: "",
  });
   const pageSize = 5;
    const { userId } = useParams();
  const dispatch = useDispatch();
  const { departmentList, currentCustomer, departmentTotal } = useSelector((state) => state.customer);
   const orgSetup = currentCustomer?.orgStructureMode || "";
  // Frontend filtering logic
  const filteredDepartmentData = useMemo(() => {
    return (departmentList || []).filter((dept) => {
      // Status Filter
      if (filters.isActive !== undefined) {
        if (dept.isActive !== filters.isActive) return false;
      }

      // Search Filter (across all fields)
      if (searchTerm) {
        const search = searchTerm.toLowerCase();
        const statusText = dept.isActive ? "active" : "inactive";
        const matches = 
          (dept.name || "").toLowerCase().includes(search) ||
          (dept.department_type || "").toLowerCase().includes(search) ||
          statusText.includes(search);
        
        if (!matches) return false;
      }

      return true;
    });
  }, [departmentList, searchTerm, filters.isActive]);

  // Map Department Data for Table
  const tableData = useMemo(() => {
    return filteredDepartmentData.map((dept, index) => {
      const row = {
        key: dept._id || index,
        serial: <div className="text-center">{index + 1}</div>,
        departmentName: <div className="text-center">{dept.name}</div>,
        departmentType: <div className="text-center">{dept.department_type || "--"}</div>,
        status: (
          <div className="text-center">
            {dept.isActive ? "Active" : "Inactive"}
          </div>
        ),
        action: (
          <div className="flex gap-4 justify-center">
            {orgSetup === "department-first" && (
              <EnvironmentOutlined
                className="text-[16px] text-[#06513D] cursor-pointer"
                onClick={() => {
                  setSelectedDeptForLink(dept);
                  setOpenLinkPopup(true);
                }}
              />
            )}
            <EditIcon  onClick={() => {
                dispatch(setSelectedDepartment(dept));
                setOpenEditBox(true);
              }} />
            <DeleteIcon
              onClick={() =>
                setDeleteConfirmation({
                  visible: true,
                  departmentId: dept._id,
                  departmentName: dept.name,
                })
              }
            />
          </div>
        ),
      };

      if (orgSetup === "department-first") {
        row.locations = (
          <div className="text-center">{dept.locationsCount || 0} Locations</div>
        );
      }

      return row;
    });
  }, [filteredDepartmentData, orgSetup, dispatch]);

  // Table Headers
  const headers = useMemo(() => {
    const baseHeaders = [
      { label: "Sr. No.", key: "serial" },
      { label: "Department Name", key: "departmentName" },
      { label: "Type", key: "departmentType" },
    ];

    if (orgSetup === "department-first") {
      baseHeaders.push({ label: "Locations", key: "locations" });
    }

    baseHeaders.push(
      { label: "Status", key: "status" },
      { label: "Action", key: "action" }
    );

    return baseHeaders;
  }, [orgSetup]);

  // Fetch all departments once or on page change
  useEffect(() => {
    if (userId) {
      dispatch(fetchAllDepartments({
        id: userId,
        pageNo: 1, // Fetch all for frontend filtering or handle pagination as needed
        pageSize: 100, // Large enough to support frontend filtering for now
      }));
    }
  }, [dispatch, userId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div>
      <CardsBorder>
        <div className="p-1">
          {/* Top Controls */}
          <div className="flex justify-between gap-2 my-3 font-medium">
            {/* Left Section */}
            <div className="flex items-center">
              <p className="text-[#06513D] px-4 text-xl">Departments</p>

              <SearchBar width="250px" onSearch={(val) => {
                setSearchTerm(val);
                setCurrentPage(1);
              }} />

              <Button
                style={{ background: "#B6D4D9", border: "solid 1px #06513D" }}
                className="text-[12px] ml-2 text-[#06513D] font-light px-4 py-5"
                onClick={() => setOpenFilter(true)}
              >
                <FilterIcon className="mr-1" />
                FILTER
              </Button>
            </div>

            {/* Right Section */}
            <div className="flex gap-2 px-10">
              <Button
                style={{ background: "#E6EEEC", border: "1px solid #06513D" }}
                className="text-sm h-[50px] text-[#06513D]"
                onClick={() => navigate(`/customer/customer-page/${userId}/import`)}
              >
                Import Department
              </Button>

              <CustomButton
                buttonType="primary"
                variant="ok"
                buttonText="+ ADD DEPARTMENT"
                className="text-sm h-[50px]"
                onClick={() => setAddDepartments(true)}
              />
            </div>
          </div>

          {/* Table */}
          <Tables
            data={tableData}
            headers={headers}
            onChange={handlePageChange}
            pageSize={pageSize}
            current={currentPage}
            total={filteredDepartmentData.length}
          />
        </div>
      </CardsBorder>
       {/* Delete Confirmation */}
      {deleteConfirmation.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="warning"
            title="Confirm Delete"
            message={`Are you sure you want to delete ${deleteConfirmation.departmentName}?`}
            showActions={true}
            confirmText="Yes, Delete"
            cancelText="Cancel"
            onCancel={() =>
              setDeleteConfirmation({
                visible: false,
                departmentName: "",
              })
            }
            onConfirm={() => {
              dispatch(deleteDepartment(deleteConfirmation.departmentId))
                .unwrap()
                .then(() => {
                  setDeleteConfirmation({
                    visible: false,
                    departmentId: null,
                    departmentName: "",
                  });

                  setSuccessPopup({
                    visible: true,
                    title: "Deleted",
                    message: "Department deleted successfully!",
                  });

                  setTimeout(() => {
                    setSuccessPopup({
                      visible: false,
                      title: "",
                      message: "",
                    });
                  }, 3000);
                })
                .catch((err) => {
                  console.error("Delete failed:", err);
                });
            }}
          />
        </div>
      )}
      {/* Success Popup */}
      {successPopup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type="success"
            title={successPopup.title}
            message={successPopup.message}
          />
        </div>
      )}
      {/* -----Add Department---- */}
      {addDepartments && (
        <AddDepartment
          onOpen={addDepartments}
          onClose={() => {
            setAddDepartments(false);
          }}
        />
      )}
      {/* ----------Edit Department------- */}
      {openEditBox && (
        <EditDepartment
          onOpen={openEditBox}
          onClose={() => {
            setOpenEditBox(false);
          }}
        />
      )}
      {/* -----------Filter---------- */}
      {openFilter && (
        <FilterLocationDeparment
          onOpen={openFilter}
          onClose={() => {
            setOpenFilter(false);
          }}
          initialStatus={filters.isActive === true ? "active" : filters.isActive === false ? "inactive" : null}
          initialType={filters.department_type}
          onApply={({ status, department_type }) => {
            let isActive = undefined;
            if (status === "active") isActive = true;
            if (status === "inactive") isActive = false;
            setFilters({ isActive, department_type });
            setCurrentPage(1); // Reset page on filter change
          }}
        />
      )}
       {/* Link Location Popup */}
      {openLinkPopup && (
        <LinkLocationPopup
          onOpen={openLinkPopup}
          onClose={() => {
            setOpenLinkPopup(false);
            setSelectedDeptForLink(null);
          }}
          departmentName={selectedDeptForLink?.name}
          departmentId={selectedDeptForLink?._id}
        />
      )}
    </div>
  );
};

export default Department;
